<template>
  <div class="carousel">
    <slot />
  </div>
</template>

<script>
import 'flickity/dist/flickity.min.css';
import Flickity from 'flickity';

require('flickity-imagesloaded');

export default {
  name: 'Carousel',
  props: {
    extraSettings: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      carousel: null,
      settings: {
        cellAlign: 'center',
        cellSelector: '.item',
        imagesLoaded: true,
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.carousel = new Flickity(this.$el, Object.assign(this.settings, this.extraSettings));
    });
  },
  beforeUnmount() {
    this.carousel.destroy();
  },
};
</script>

<style scoped lang="scss">
.item {
  width: 100%;
}
</style>
